import Dropdown from "../../components/Dropdown"
import DateRangeControl from "../../components/DateRangeControl"

export const statusOptions = ["All", "Success", "Errored"]

const clearButtonClass =
  "px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors text-sm font-medium disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400"

/*
  The filter card.

  Do not wrap this in an `overflow-hidden` container: the date range's
  calendar popover would be clipped by it.
*/
const VideoLogsFilterBar = ({
  dateRangeCustomLabel,
  dateRangePresets,
  dateRangeTriggerLabel,
  dateRangeValue,
  status,
  patientIssuer,
  issuerOptions,
  onGetDateRangeCustomSeed,
  onSelectDateRangePreset,
  onApplyCustomDateRange,
  onStatus,
  onPatientIssuer,
  onClearFilters,
}) => (
  <div className="bg-gray-50 p-4 rounded-lg">
    <div className="flex flex-wrap gap-4">
      <div title="Filter by date range">
        <label className="block text-xs font-medium mb-1 ml-1">
          DATE RANGE
        </label>
        <DateRangeControl
          customLabel={dateRangeCustomLabel}
          getCustomSeed={onGetDateRangeCustomSeed}
          presets={dateRangePresets}
          triggerLabel={dateRangeTriggerLabel}
          value={dateRangeValue}
          onApplyCustom={onApplyCustomDateRange}
          onSelectPreset={onSelectDateRangePreset}
        />
      </div>

      <div>
        <Dropdown
          label="STATUS"
          options={statusOptions}
          setValue={onStatus}
          title="Filter by success/error status"
          value={status}
        />
      </div>

      <div>
        <Dropdown
          label="PATIENT ISSUER"
          options={issuerOptions}
          setValue={onPatientIssuer}
          title="Filter by patient issuer"
          value={patientIssuer}
        />
      </div>

      <div className="flex items-end gap-2">
        <button
          className={clearButtonClass}
          title="Clear all filters"
          onClick={onClearFilters}
        >
          Clear
        </button>
      </div>
    </div>
  </div>
)

export default VideoLogsFilterBar
